import { Truck, Clock, PackageCheck, ShieldAlert, Mail } from "lucide-react";
import { MaskLines, Reveal } from "../components/Motion";
import { Footer } from "../components/Footer";
import { BUSINESS_EMAIL } from "../components/Contact";

const BLOCKS = [
  { id: "free", Icon: Truck, title: "Free shipping", body: <>Every order ships <strong>FREE</strong> anywhere in the United States. No minimums, no surprise fees at checkout.</> },
  { id: "processing", Icon: Clock, title: "4–5 business days", body: <>Orders take <strong>4–5 business days</strong> to ship and arrive at your door.</> },
  { id: "delivery", Icon: PackageCheck, title: "Order updates", body: <>You'll get an order confirmation email with your order number as soon as you check out.</> },
];

export default function Shipping() {
  return (
    <main data-testid="shipping-page" className="bg-[#F6F3EF]">
      <section className="px-5 sm:px-10 lg:px-16 pt-32 pb-24">
        <p className="font-mono-x uppercase text-xs tracking-[0.25em] text-[#E10600] font-bold">The fine print — but bold</p>
        <h1 className="font-display uppercase text-6xl sm:text-8xl lg:text-9xl leading-[0.86] mt-4" data-testid="shipping-headline">
          <MaskLines lines={["Shipping", <span key="r" className="text-[#E10600]">& returns.</span>]} />
        </h1>

        <div className="mt-14 grid md:grid-cols-3 gap-4">
          {BLOCKS.map(({ id, Icon, title, body }, i) => (
            <Reveal key={id} delay={i * 0.06}>
              <div className="h-full bg-white border-2 border-[#0B0B0B] p-6 sm:p-8" data-testid={`shipping-block-${id}`}>
                <Icon className="w-8 h-8 text-[#E10600]" />
                <h2 className="font-display uppercase text-3xl mt-5">{title}</h2>
                <p className="mt-3 font-semibold leading-relaxed">{body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-4">
          <div className="bg-[#E10600] text-white p-6 sm:p-10 shadow-[10px_10px_0_#0B0B0B]" data-testid="refund-policy">
            <ShieldAlert className="w-10 h-10" />
            <h2 className="font-display uppercase text-4xl sm:text-6xl leading-[0.9] mt-5">No refunds — unless it shows up damaged.</h2>
            <p className="mt-5 max-w-2xl text-lg font-bold">
              All sales are final. There will be no refunds unless your order was damaged during shipping.
            </p>
            <ol className="mt-6 space-y-2 font-semibold list-decimal pl-5 max-w-2xl">
              <li>Email us as soon as your order arrives damaged.</li>
              <li>Include your order number (it's in your confirmation email, e.g. X-AB12CD34).</li>
              <li>Attach clear photos of the damaged hat and the shipping package.</li>
            </ol>
          </div>
        </Reveal>

        <Reveal className="mt-4">
          <a href={`mailto:${BUSINESS_EMAIL}`} data-testid="shipping-email-link" className="group flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-[#0B0B0B] text-white p-6 sm:p-8 transition-colors duration-300 hover:bg-[#E10600]">
            <span className="flex items-center gap-4">
              <Mail className="w-8 h-8 shrink-0" />
              <span className="font-display uppercase text-2xl sm:text-3xl">Questions about your order?</span>
            </span>
            <span className="font-semibold break-all">{BUSINESS_EMAIL}</span>
          </a>
        </Reveal>
      </section>
      <Footer />
    </main>
  );
}
